import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { useLang } from "@/context/LangContext";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, setTheme } = useTheme();
  const { t } = useLang();
  const light = theme === "light";
  return (
    <button
      type="button"
      onClick={() => setTheme(light ? "dark" : "light")}
      title={light ? t("الوضع الليلي", "Dark mode") : t("الوضع النهاري", "Light mode")}
      aria-label={light ? "Dark mode" : "Light mode"}
      className={`relative inline-flex items-center h-9 w-[4.25rem] rounded-full border border-primary/40 bg-secondary/80 px-1 transition-colors hover:border-primary ${className}`}
      data-testid="theme-toggle"
      translate="no"
    >
      <span className={`absolute top-1 h-7 w-7 rounded-full bg-primary text-white flex items-center justify-center shadow transition-transform duration-300 ${light ? "translate-x-0" : "translate-x-[1.9rem]"}`} style={{ left: 4 }}>
        {light ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      </span>
      <Sun className={`w-3.5 h-3.5 absolute left-2.5 ${light ? "opacity-0" : "opacity-60"}`} />
      <Moon className={`w-3.5 h-3.5 absolute right-2.5 ${light ? "opacity-60" : "opacity-0"}`} />
    </button>
  );
};
